var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scroll-layout"},[(_vm.$slots.header)?_c('div',{ref:"Header",staticClass:"scroll-layout-header"},[_vm._t("header")],2):_vm._e(),_c('el-scrollbar',{ref:"scrollbar",class:{
      'scroll-layout-content': true,
      'footer-absolute': _vm.footerType === 'fixed',
    }},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }